// extracted by mini-css-extract-plugin
export default {"userLayout":"styles_userLayout__K4ZL-","header":"styles_header__fxUju","authHeader":"styles_authHeader__vafAc","content":"styles_content__n65Ec"};